import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTopMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-top-medium"} maskId="square-filled-radius-0-stroke-1-IconChevronTopMedium"><path d="M19.207 14.5L18.5 15.207L12 8.70703L5.5 15.207L4.79297 14.5L12 7.29297L19.207 14.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronTopMedium;
